import { cn } from "@/lib/utils";

export const PageHeader = ({ title, subtitle, children, testid }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 animate-fade-up" data-testid={testid}>
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2">{children}</div>}
  </div>
);

const STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-800",
  compliant: "bg-emerald-100 text-emerald-800",
  verified: "bg-emerald-100 text-emerald-800",
  completed: "bg-emerald-100 text-emerald-800",
  pass: "bg-emerald-100 text-emerald-800",
  draft: "bg-sky-100 text-sky-800",
  open: "bg-amber-100 text-amber-800",
  warning: "bg-amber-100 text-amber-800",
  expired: "bg-rose-100 text-rose-800",
  fail: "bg-rose-100 text-rose-800",
  archived: "bg-slate-100 text-slate-600",
};

export const StatusBadge = ({ status }) => {
  const key = (status || "").toLowerCase();
  return (
    <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize",
      STATUS_STYLES[key] || "bg-slate-100 text-slate-700")}>
      {status || "—"}
    </span>
  );
};

export const DaysBadge = ({ days }) => {
  if (days === null || days === undefined) return <span className="text-slate-400 text-xs">No date</span>;
  let cls = "bg-emerald-100 text-emerald-800";
  let label = `${days} days`;
  if (days < 0) { cls = "bg-rose-100 text-rose-800"; label = `Expired ${Math.abs(days)}d ago`; }
  else if (days <= 30) { cls = "bg-rose-100 text-rose-800"; label = `${days} days`; }
  else if (days <= 60) { cls = "bg-amber-100 text-amber-800"; label = `${days} days`; }
  return <span className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold", cls)}>{label}</span>;
};

export const EmptyState = ({ icon: Icon, title, hint }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {Icon && <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-4"><Icon className="w-7 h-7 text-slate-400" /></div>}
    <p className="font-heading font-semibold text-slate-700">{title}</p>
    {hint && <p className="text-sm text-slate-400 mt-1 max-w-sm">{hint}</p>}
  </div>
);

export const ReadOnlyNote = () => (
  <span className="text-xs text-amber-600 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-md">View-only access</span>
);
